import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { NewOrderApi } from '../api/newOrderApi';
import { OrderTypeDescriptor } from '../types';

const QUERY_KEY_ORDER_TYPES = 'order-types';
export const useOrderTypes = () =>
  useQuery<OrderTypeDescriptor[], AxiosError>({
    queryKey: [QUERY_KEY_ORDER_TYPES],
    queryFn: NewOrderApi.orderTypes,
  });
